import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, ShieldCheckIcon } from 'lucide-react';
export function ProfessionalAffiliation() {
  return <section className="w-full py-20 lg:py-24 bg-gradient-to-br from-brand-navy via-brand-deep to-brand-navy relative overflow-hidden" data-id="element-353">
      <div className="absolute inset-0" data-id="element-354">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl" data-id="element-355" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-primary/10 rounded-full blur-3xl" data-id="element-356" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-357">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-12 px-4" data-id="element-358">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/20 rounded-full mb-4" data-id="element-359">
            <BuildingIcon className="w-4 h-4 text-brand-gold" data-id="element-360" />
            <span className="text-brand-gold font-semibold text-xs sm:text-sm uppercase tracking-wider" data-id="element-361">
              Professional Affiliation
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6" data-id="element-362">
            Affiliated With Derma Lipo Laser
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto px-4" data-id="element-363">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 border border-brand-gold/20" data-id="element-364">
            <p className="text-lg sm:text-xl text-white/90 leading-relaxed mb-4 sm:mb-6" data-id="element-365">
              Dr. Mark Joy is professionally affiliated with Derma Lipo Laser,
              working within a clinical environment that prioritizes patient
              safety, professional medical protocols, and ethical care.
            </p>
            <p className="text-base sm:text-lg text-white/80 leading-relaxed" data-id="element-366">
              This affiliation ensures that consultations are supported by
              proper medical protocols and professional infrastructure.
            </p>

            <div className="mt-8 sm:mt-10 flex flex-wrap gap-3 sm:gap-4 md:gap-6 justify-center" data-id="element-367">
              <div className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20" data-id="element-368">
                <ShieldCheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold flex-shrink-0" data-id="element-369" />
                <span className="text-white font-medium text-xs sm:text-sm md:text-base whitespace-nowrap" data-id="element-370">
                  Medical Standards
                </span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20" data-id="element-371">
                <ShieldCheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold flex-shrink-0" data-id="element-372" />
                <span className="text-white font-medium text-xs sm:text-sm md:text-base whitespace-nowrap" data-id="element-373">
                  Patient Safety
                </span>
              </div>
              <div className="flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20" data-id="element-374">
                <ShieldCheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold flex-shrink-0" data-id="element-375" />
                <span className="text-white font-medium text-xs sm:text-sm md:text-base whitespace-nowrap" data-id="element-376">
                  Ethical Care
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}